import { inject, ref } from 'vue'

import featureNames from '@/lib/featureNames'
import { Feature } from '@/plugins/feature-config'
/**
 * Composable to manage feature flags.
 * Provides functionality to check if a feature is active and retrieve the feature configuration.
 */
export default function useFeature() {
  const features = inject('features')
  // Feature names and configuration
  const featureNameList = ref(featureNames)
  /**
   * Check if a feature is active.
   * @param {string} featureSlug - the unique identifier for the feature
   * @returns {boolean} - whether the feature is active
   */
  const isFeatureActive = (featureSlug) => {
    return features?.feature?.(featureSlug)?.isActive ?? false
  }
  /**
   * Get the feature configuration for a given slug.
   * @param {string} featureSlug - the unique identifier for the feature
   * @returns {object|null} - the feature configuration or null if not found
   */
  const getFeature = (featureSlug) => {
    return features?.feature?.(featureSlug) ?? null
  }
  return {
    featureNameList,
    isFeatureActive,
    getFeature,
    Feature,
  }
}
